// Klaviyo form success handler for the footer newsletter form (Vz5UDX)
// Docs: https://help.klaviyo.com/hc/en-us/articles/115005082927
//
// On "submit" event from the footer Klaviyo form:
//  - add class 'is-submitted' to .c-page-footer__newsletter-form
//  - CSS rules (in _page-footer.scss) hide .klaviyo-form-Vz5UDX and show
//    .c-page-footer__newsletter-success via the class
//
// Why CSS class instead of inline style?
//   Klaviyo re-renders its form DOM on viewedStep (fires AFTER submit),
//   which can reset inline styles. CSS rules with !important on the parent
//   class survive any Klaviyo DOM mutations.
//
// The listener is attached directly to window — NOT inside DOMContentLoaded,
// because Klaviyo may dispatch the event before that lifecycle fires.

window.addEventListener('klaviyoForms', function (e) {
  if (e.detail.type === 'submit' && e.detail.formId === 'Vz5UDX') {
    const formContainer = document.querySelector('.c-page-footer__newsletter-form');

    if (!formContainer) {
      return;
    }

    // Add class — CSS rules do the rest (survives Klaviyo DOM re-renders)
    formContainer.classList.add('is-submitted');

    // Also set inline styles as immediate fallback
    const klaviyoForm = formContainer.querySelector('[class*="klaviyo-form-Vz5UDX"]');
    const successMessage = formContainer.querySelector('.c-page-footer__newsletter-success');

    if (klaviyoForm) {
      klaviyoForm.style.setProperty('display', 'none', 'important');
    }

    if (successMessage) {
      successMessage.style.setProperty('display', 'flex', 'important');
    }
  }
});
